import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import * as constants from "../mixins/constants";
import course from "../modules/training/store";
import signUp from "../modules/sign-up/store";
import signIn from "../modules/sign-in/store";
import attachFile from "../modules/attach-file/store";
import profile from "../modules/profile/store";
import covidTest from "../modules/covid-test/store";

Vue.use(Vuex);

const types = {
  LOADING_ORDER: "LOADING_ORDER",
  SET_ISFOCUS_TAB: "SET_ISFOCUS_TAB",
  DISABLE_LOADING: "DISABLE_LOADING",
  UPDATE_LOCALE: "UPDATE_LOCALE",
  UPDATE_RATING_SUPPLIER: "UPDATE_RATING_SUPPLIER",
  SET_STATUS_SIGNUP: "SET_STATUS_SIGNUP",
  SET_STATUS_SIGN_IN_STEP_1: "SET_STATUS_SIGN_IN_STEP_1",
  SET_STATUS_SIGN_IN_STEP_2: "SET_STATUS_SIGN_IN_STEP_2",
  SET_STEP: "SET_STEP",
  SET_TOKEN: "SET_TOKEN",
};

export default new Vuex.Store({
  modules: {
    course,
    signUp,
    signIn,
    attachFile,
    profile,
    covidTest
  },
  state: {
    layout: "default",
    active_step: 1,

    loading_order: false,
    isDisableLoading: false,
    locale: "vi",
    isFocusTab: true,
    rate: null,
    isSignUp: true,
    step: 3,
    statusStep: [
      {
        step: 1,
        isSuccess: true
      },
      {
        step: 2,
        isSuccess: true
      },
      {
        step: 3,
        isSuccess: false
      },
      {
        step: 4,
        isSuccess: false
      },
      {
        step: 5,
        isSuccess: false
      }
    ]
  },
  mutations: {
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    },
    SET_ACTIVE_STEP(state, payload) {
      state.active_step = payload;
    },

    [types.LOADING_ORDER](state, data) {
      state.loading_order = data;
    },
    [types.SET_ISFOCUS_TAB](state, data) {
      state.isFocusTab = data;
    },
    [types.DISABLE_LOADING](state) {
      state.isDisableLoading = true;
    },
    [types.UPDATE_LOCALE](state, data) {
      state.locale = data;
    },
    [types.UPDATE_RATING_SUPPLIER](state, data) {
      state.rate = data;
    },
    [types.SET_STATUS_SIGNUP](state, data) {
      state.isSignUp = data;
    },
    [types.SET_STATUS_SIGN_IN_STEP_1](state, data) {
      state.isSignInStep1 = data;
    },
    [types.SET_STATUS_SIGN_IN_STEP_2](state, data) {
      state.isSignInStep2 = data;
    },
    [types.SET_STEP](state, data) {
      state.step = data;
    }
  },
  actions: {
    setIsfocusTab: ({ commit }, value) => {
      commit(types.SET_ISFOCUS_TAB, value);
    },
    disableLoading: ({ commit }) => {
      commit(types.DISABLE_LOADING);
    },
    updateLocale: ({ commit }, lang) => {
      commit(types.UPDATE_LOCALE, lang);
    },
    // ratingSupplier: ({ commit }, { orderId, userId, rate, comment }) => {
    //   const payload = {
    //     params: {
    //       user_id: userId,
    //       order_id: orderId,
    //       rating: rate,
    //       comment,
    //       type: "receiver"
    //     }
    //   };
    //   const api = `${process.env.VUE_APP_API_URL}${constants.API.supplier.rating}`;
    //   window.axios
    //     .get(api, payload)
    //     .then(response => {
    //       if (response && response.data) {
    //         commit(types.UPDATE_RATING_SUPPLIER, rate);
    //       }
    //     })
    //     .catch(error => {
    //       console.error(error);
    //     });
    // },
    updateStatusSignUp({ commit }, value) {
      commit(types.SET_STATUS_SIGNUP, value);
    },
    updateStatusSignInStep1({ commit }, value) {
      commit(types.SET_STATUS_SIGN_IN_STEP_1, value);
    },
    updateStatusSignInStep2({ commit }, value) {
      commit(types.SET_STATUS_SIGN_IN_STEP_2, value);
    },
    nextStep({ commit }, value) {
      commit(types.SET_STEP, value);
    },

  },
  getters: {
    layout(state) {
      return state.layout;
    },
    activeStep(state) {
      return state.active_step;
    },

    formatTime: state => {
      return state.locale === constants.DEFAULT_LOCATE
        ? "dddd, ngày DD/MM"
        : "dddd Do MMM";
    },
    formatSameDayTime: state => {
      return state.locale === constants.DEFAULT_LOCATE ? "HH:mm" : "hh:mm A";
    },
    formatDiffDayTime: state => {
      return state.locale === constants.DEFAULT_LOCATE
        ? "dddd, ngày DD/MM HH:mm"
        : "dddd Do MMM hh:mm A";
    },
    formatTimeCalendar: () => time => {
      if (time) {
        const formatTime = "DD-MM-Y, H:mm";
        return moment.unix(time).calendar(null, {
          lastDay() {
            return formatTime;
          },
          lastWeek() {
            return formatTime;
          },
          nextDay() {
            return formatTime;
          },
          nextWeek() {
            return formatTime;
          },
          sameElse: formatTime
        });
      } else return "";
    },
    step: state => state.step,
    isSignUp: state => state.isSignUp,
    isSignInStep1: state => state.isSignInStep1,
    isSignInStep2: state => state.isSignInStep2,
    // token: state => state.token,
    statusStep: state => state.statusStep
  }
});
